/**
 * api/client.js
 *
 * Central Axios instance for all API calls.
 * - Automatically attaches JWT token from localStorage
 * - Handles 401 (auto-logout) globally
 *
 * TO CHANGE API URL: Update REACT_APP_API_URL in .env
 * TO ADD NEW API CALLS: Create a new file in src/api/ (see examples below)
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '/api');

const client = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Request Interceptor: attach token ───────────────────────────────────────
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('drusshti_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response Interceptor: handle global errors ───────────────────────────────
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRoute = error.config?.url?.includes('/auth/') && error.config?.url?.includes('/login');
      if (!isLoginRoute) {
        localStorage.removeItem('drusshti_token');
        localStorage.removeItem('drusshti_user');
        localStorage.removeItem('drusshti_role');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
